'use strict';

angular.module('breakmarkApp').controller('storePackagesTableEditPackageModal', function ($scope, $rootScope, $Products, $q, Upload, $timeout, $uibModalInstance, theStore, thePackage) {

    console.log('testing', theStore, thePackage);

    const storage = firebase.storage();
    const storageRef = firebase.storage().ref();

    // scope.fileUploadProgress = 0;
    $scope.uploadingThumbnail = false;
    $scope.thePackage = thePackage;
    $scope.theStore = theStore;
    $scope.uploadingImage = false;

    $scope.close = function() {

        $uibModalInstance.dismiss('cancel');

    };

    $scope.submit = function() {

        // $element.modal('hide');
        // close(null, 1000);
        $scope.theStore.$save().then(() => {
            $uibModalInstance.close($scope.theStore);
        });
    };

    $scope.uploadThumbnail = function (thumbnail) {

        $scope.thumbnail = thumbnail;

        $scope.uploadingThumbnail = true;

        // TODO: Add a check here to see if we have a file by that name already

        if (thumbnail && thumbnail.length) {

            _.forEach(thumbnail, function(file) {

               var uploadThumbnailTask = storageRef.child('stores/' + $scope.theStore.$id + '/packages/' + file.name).put(file);

               uploadThumbnailTask.on('state_changed', function(snapshot){
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

                }, function(error) {
                    // Handle unsuccessful uploads
                    switch (error.code) {
                      case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                      case 'storage/canceled':
                        // User canceled the upload
                        break;

                      case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    }
                }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    $scope.thePackage.thumbnail = {
                        fileRef: uploadThumbnailTask.snapshot.ref.fullPath,
                        file: uploadThumbnailTask.snapshot.downloadURL
                    };

                    $scope.uploadingThumbnail = false;

                    $scope.theStore.$save();

                });

            });
        }

    };

    $scope.removeThumbnail = function() {

        console.log('thumbnailToDelete to delete', $scope.thePackage.thumbnail);

        let deleteThumbnailRef = storageRef.child($scope.thePackage.thumbnail.fileRef);

        deleteThumbnailRef.delete().then(function() {

            $scope.thePackage.thumbnail = null;

            $scope.theStore.$save();
            // File deleted successfully
        }).catch(function(error) {
            // Uh-oh, an error occurred!
            console.log('ERROR', error);

            if(error.code === 'storage/object-not-found'){

                // it appears as though our error is a 404, let's just remove the image ref just for fun and profit

                $scope.thePackage.thumbnail = null;
                console.log('file ref deleted after error');

                $scope.theStore.$save();

            }
        });

    }

});
